import React, { useEffect, useState, useMemo, useRef } from "react";
import { Bar } from "react-chartjs-2";
import "./Vertical.css";
const Vertical = ({ reservations }) => {
  const [dataMonths, setDataMonths] = useState([]);
  const actualMonth = new Date().getMonth() + 1;
  let sortedMonths = useRef();
  const months = useMemo(
    () => [
      "Styczeń",
      "Luty",
      "Marzec",
      "Kwiecień",
      "Maj",
      "Czerwiec",
      "Lipiec",
      "Sierpień",
      "Wrzesień",
      "Październik",
      "Listopad",
      "Grudzień",
    ],
    []
  );
  if (actualMonth < 6) {
    const [...monthsCopy] = months;
    const count = 6 - actualMonth - 1;
    const monthsEnd = monthsCopy.reverse().splice(0, count + 1);
    const monthsStart = monthsCopy.reverse().splice(0, 6 - monthsEnd.length);
    sortedMonths.current = monthsEnd.concat(monthsStart);
  } else {
    sortedMonths.current = months.slice(actualMonth - 6, actualMonth);
  }
  useEffect(() => {
    let elements = [];
    if (sortedMonths.current) {
      for (let i = 0; i < 6; i++) {
        const element = `${months.indexOf(sortedMonths.current[i]) + 1}`;
        const elementNumber = element <= 9 ? `0${element}` : element;
        const elementData = reservations.filter(
          (r) => r.arriveData.substr(5, 2) === elementNumber
        );
        elements.push(elementData.length);
      }
    }
    setDataMonths(elements);
  }, [months, reservations, sortedMonths]);
  console.log(sortedMonths.current, dataMonths);
  const data = {
    labels: sortedMonths.current,
    datasets: [
      {
        label: "Statystyki miesięczne",
        data: dataMonths,
        backgroundColor: [
          "rgba(255, 99, 132, 0.2)",
          "rgba(54, 162, 235, 0.2)",
          "rgba(255, 206, 86, 0.2)",
          "rgba(75, 192, 192, 0.2)",
          "rgba(153, 102, 255, 0.2)",
          "rgba(255, 159, 64, 0.2)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };
  const options = {
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };
  return (
    <div className="bar">
      <Bar data={data} options={options} />
    </div>
  );
};

export default Vertical;
